import { environment } from 'src/environments/environment';

export class InActivityTimerConst {
  static readonly MINUTES_IDLE_ALLOWED = environment.name === 'dev' ? 5 : 27;

  static readonly LOGOUT_WARNING_DURATION_IN_MINS =
    environment.name === 'dev' ? 1 : 3;
}
